import { useState } from 'react';
import { Tabs, TabList, Tab, TabPanels, TabPanel, Flex } from '@chakra-ui/react';
import { PageContent } from 'src/components/PageContent';
import { SectionBox } from 'src/components/SectionBox';
import CenteredSpinner from '@/components/CenterSpinner/CenteredSpinner';
import { breadcrumb } from './breadcrumb';
import { SMTPConfigTab } from './components/SMTPConfigTab';
import { useTranslation } from 'react-i18next';
import { NotificationsTab } from './components/NotificationsTabPush';

export const CommunicationCentral = () => {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <PageContent title={t('pages.communication_central.communication_central_page_title')} breadcrumbItems={breadcrumb}>
      <SectionBox bodyProps={{ gap: 'small', p: 0 }}>
        <Tabs position='relative' variant='unstyled' tabIndex={tabIndex} onChange={tabIndex => setTabIndex(tabIndex)}>
          <Flex
            overflow='auto'
            sx={{
              scrollbarWidth: 'none',
              '::-webkit-scrollbar': {
                display: 'none',
              },
            }}
          >
            <TabList
              whiteSpace='nowrap'
              flex={1}
              borderTopWidth='8px'
              borderTopRadius='8px'
              borderTopColor='gray.200'
              sx={{
                scrollbarWidth: 'none',
                '::-webkit-scrollbar': {
                  display: 'none',
                },
              }}
            >
              <Tab
                minW='fit-content'
                position='relative'
                color='text.main'
                _selected={{
                  color: 'brand.500',

                  '::before': {
                    content: '""',
                    display: 'block',
                    width: '100%',
                    height: '8px',
                    borderTopLeftRadius: 8,
                    backgroundColor: 'brand.500',
                    position: 'absolute',
                    top: '-8px',
                    zIndex: 99,
                  },
                }}
              >
                {t('pages.communication_central.communication_central_notifications_tab')}
              </Tab>

              <Tab
                minW='fit-content'
                position='relative'
                color='text.main'
                _selected={{
                  color: 'brand.500',

                  '::before': {
                    content: '""',
                    display: 'block',
                    width: '100%',
                    height: '8px',
                    backgroundColor: 'brand.500',
                    position: 'absolute',
                    top: '-8px',
                    zIndex: 99,

                    '@media (max-width: 529px)': {
                      borderTopRightRadius: '8px',
                    },
                  },
                }}
              >
                {t('pages.communication_central.communication_central_smtp_config_tab')}
              </Tab>
            </TabList>
          </Flex>

          <TabPanels>
            <TabPanel p={8}>
              <NotificationsTab />
            </TabPanel>

            <TabPanel p={8}>
              <SMTPConfigTab />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </SectionBox>

      <CenteredSpinner isLoading={false} />
    </PageContent>
  );
};
